/* eslint-disable no-undef */
import axios from 'axios';

const api = axios.create({
  headers: {
    accept: '*/*',
    'Content-Type': 'application/json-patch+json',
    'Access-Control-Allow-Origin': '*',
  },
  baseURL: process.env.REACT_APP_AUTH,
});

api.interceptors.request.use((config) => {
  const token = sessionStorage.getItem('@auth/token');
  const headers = { ...config.headers };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return { ...config, headers };
});

/* axios.interceptors.response.use(
  (response) => {
    requestCache.setCachedResponse(response.config, response);
    return response;
  },
  (error) => {
    if (error.isSkipXHR) {
      return requestCache.getCachedResponse(error.request);
    }
    return Promise.reject(error);
  }
);

axios.interceptors.request.use((config) => {
  if (requestCache.isCached(config)) {
    const skipXHRError = new Error('skip');
    skipXHRError.isSkipXHR = true;
    skipXHRError.request = config;
    throw skipXHRError;
  } else {
    if (requestCache.shouldThrottle(config)) {
      requestCache.waitForResponse(config);
    }
    return config;
  }
}); */

export default api;
